import axios from 'axios';
import { io, Socket } from 'socket.io-client';
import env from '../environment';
import emitAck, { SessionToken } from './emits/ack';
import listenAck from './listens/ack';
import listenReceiveCheckRoomPassword from './listens/receiveCheckRoomPassword';
import listenReceiveDestroyRoom from './listens/receiveDestroyRoom';
import listenReceiveJoinUser from './listens/receiveJoinUser';
import listenReceiveLeaveUser from './listens/receiveLeaveUser';
import listenReceiveMessage from './listens/receiveMessage';
import listenReceiveMessages from './listens/receiveMessages';
import listenReceiveMyInfo from './listens/receiveMyInfo';
import listenReceiveResponseCreateRoom from './listens/receiveResponseCreateRoom';
import listenReceiveResponseJoinRoom from './listens/receiveResponseJoinRoom';
import listenReceiveRoomDetail from './listens/receiveRoomDetail';
import listenReceiveRooms from './listens/receiveRooms';
import listenReceiveUserDetails from './listens/receiveUserDetails';
import listenReceiveUsers from './listens/receiveUsers';

axios.defaults.withCredentials = true;

export let socket: Socket | null = null;

let user: string = '@0000';
export const setUser = (_user: string) => user = _user;
export const getUser = () => user;

export const connector = async () => {
  socket = io(`${env.SERVER_URL}:4000`);

  const sessionToken = await axios.get(`${env.SERVER_URL}/chat/get_session.php`);
  emitAck(sessionToken.data as SessionToken);

  listenAck(() => {
    listenReceiveUsers();
    listenReceiveUserDetails();
    listenReceiveMessages();
    listenReceiveMessage();
    listenReceiveJoinUser();
    listenReceiveLeaveUser();
    listenReceiveResponseCreateRoom();
    listenReceiveResponseJoinRoom();
    listenReceiveRoomDetail();
    listenReceiveMyInfo();
    listenReceiveRooms();
    listenReceiveCheckRoomPassword();
    listenReceiveDestroyRoom();
  });

  console.log('connection is fine.');
}